import { Box, Button, Fade, Link, Paper, Typography } from '@mui/material';

const Refer = () => {
	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
				mt: 4,
			}}
		>
			<Fade in>
				<Box
					sx={{
						px: 2,
						py: 4,
						textAlign: 'center',
						display: 'flex',
						flexDirection: 'column',
						maxWidth: 700,
						marginLeft: 'auto',
						marginRight: 'auto',
					}}
					gap={2}
				>
					<Typography component='h1' color='primary' sx={{ fontSize: 30, fontWeight: 'bold' }}>
						Oops!
					</Typography>
					<Typography component='h2' sx={{ fontSize: 20 }}>
						There has been a problem. Your policy could not be renewed
					</Typography>
					<Typography sx={{ mt: 2 }}>
						Please contact one of our agents on webchat on{' '}
						<Link
							sx={{
								textDecoration: 'none',
							}}
							href='https://www.carrotinsurance.com/'
							target='_blank'
							rel='noreferrer'
						>
							our main website.
						</Link>
					</Typography>

					<Button variant='contained' color='secondary' href='/'>
						Home
					</Button>
				</Box>
			</Fade>
		</Paper>
	);
};

export default Refer;
